module.exports = __webpack_public_path__ + "static/media/type_c_id.02ddfdae.png";